var _defs, _rect, _rect2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 40,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#1a1a2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40 0 L 0 0 0 40",
    fill: "none",
    stroke: "#252540",
    strokeWidth: 1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#grid)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 1880,
    height: 1040,
    fill: "none",
    stroke: "#444",
    strokeWidth: 2,
    strokeDasharray: "15,8"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 960,
    y: 500,
    fontFamily: "Arial, sans-serif",
    fontSize: 48,
    fill: "#555",
    textAnchor: "middle"
  }, "MISSING BACKGROUND")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 960,
    y: 570,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#444",
    textAnchor: "middle"
  }, "DEV MODE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderBackground);
export default __webpack_public_path__ + "static/media/placeholder-background.aba79a9f67c49d99fa5321df4d0c4068.svg";
export { ForwardRef as ReactComponent };